package com.appcreator.client.firebase.storage


import coil3.ImageLoader
import coil3.Uri
import coil3.fetch.FetchResult
import coil3.fetch.Fetcher
import coil3.request.Options
import coil3.toUri
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.storage.storage


class FirebaseStorageFetcher(
    private val options: Options,
    private val data: Uri,
    private val imageLoader: ImageLoader
) : Fetcher {

    class Factory : Fetcher.Factory<Uri> {
        override fun create(data: Uri, options: Options, imageLoader: ImageLoader): Fetcher? {
            return if (data.scheme == "firebasestorage") {
                FirebaseStorageFetcher(options, data, imageLoader)
            } else {
                null // Return null if this fetcher can't handle the data.
            }
        }
    }

    override suspend fun fetch(): FetchResult? {
        val firebasePath = data.authority + data.path.orEmpty()
        if (firebasePath.isBlank()) {
            return null
        }

        try {
            val downloadUrl = Firebase.storage.reference(firebasePath)
                .getDownloadUrl()
            println("FirebaseStorageFetcher - downloadUrl - $downloadUrl")
            val httpFetcher = imageLoader.components.newFetcher(
                data = downloadUrl.toUri(),
                options = options,
                imageLoader = imageLoader
            )
            return httpFetcher?.first?.fetch()
        } catch (e: Exception) {
            println("FirebaseStorageFetcher - Failed to fetch image - $e")
            return null
        }
    }
}
